import React, { useEffect } from "react";
import { Row, Col } from "reactstrap";
import TheBizLogo from "./../../Images/dinbiz-logo.png";
import QuestionMarkIcon from "./../../Images/question-mark.png";
import SaveToCloudIcon from "./../../Images/save-to-cloud.png";
import ExitIcon from "./../../Images/white-x.png";
import UserIcon from "./../../Images/user.png";
import { useAuth } from "../../Context/AuthContext";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";

const Header = ({ setHelpModalActive, setHelpModalContent }) => {
  const currentPage = useSelector((state) => state.activePage);

  const { logout, saveToDatabase, subscriptionData } = useAuth();

  const history = useHistory();

  function handleLogout() {
    logout();
    history.push("/login");
  }

  // check if trial is active. If trial is active open helpmodal on render
  useEffect(() => {
    async function processSubscriptionData(subscriptionData) {
      if (subscriptionData) {
        await Promise.all(
          Object.keys(subscriptionData).map(async (key) => {
            const seconds = subscriptionData[key].trial_end.seconds * 1000;
            const isTrialExpired = seconds < Date.now();
            if (!isTrialExpired) {
              await setHelpModalActive(true);
            }
          })
        );
      }
    }
    processSubscriptionData();
  }, [setHelpModalActive, subscriptionData]);

  const handleHelpModal = () => {
    setHelpModalActive(true);
    setHelpModalContent("1.0");
  };
  const handleProfileSettings = () => {
    setHelpModalActive(true);
    setHelpModalContent("11.0");
  };
  return (
    <Row className="master-header mb-2">
      <Col>
        <Row style={{ maxWidth: "1440px", margin: "0 auto" }}>
          <Col
            xs={4}
            className="d-flex align-items-center justify-content-center"
            style={{ padding: "0px" }}
          >
            <img
              src={TheBizLogo}
              alt="logo"
              className="img-fluid max-width:100% height:auto mx-auto d-block p-1"
            />
          </Col>

          {currentPage === "Produktmixern" ||
          currentPage === "Fastakostnader" ||
          currentPage === "Åtgärder" ||
          currentPage === "Lonekalkyl" ? (
            <Col
              xs={1}
              className="offset-28 master-header-button p-1"
              style={{ padding: "0px" }}
              onClick={handleHelpModal}
            >
              <Row className="g-0">
                <Col
                  xs={40}
                  className="d-flex align-items-center justify-content-center"
                >
                  <img
                    src={QuestionMarkIcon}
                    alt="question mark icon"
                    className="img-fluid max-width:100% height:auto mx-auto d-block w-75 pt-1"
                  />
                </Col>
              </Row>
              <Row className="g-0">
                <Col
                  xs={40}
                  className="d-flex align-items-center justify-content-center"
                >
                  <span
                    className="text-white fw-bold master-header-button-text pb-1"
                    style={{ lineHeight: "1" }}
                  >
                    Hjälp
                  </span>
                </Col>
              </Row>
            </Col>
          ) : (
            ""
          )}

          {currentPage === "Produktmixern" ||
          currentPage === "Fastakostnader" ||
          currentPage === "Åtgärder" ||
          currentPage === "Lonekalkyl" ? (
            <Col
              xs={1}
              className="offset-1 master-header-button p-1"
              style={{ padding: "0px" }}
              onClick={saveToDatabase}
            >
              <Row className="g-0">
                <Col
                  xs={40}
                  className="d-flex align-items-center justify-content-center"
                >
                  <img
                    src={SaveToCloudIcon}
                    alt="save to cloud icon"
                    className="img-fluid max-width:100% height:auto mx-auto d-block w-75 pt-1"
                  />
                </Col>
              </Row>
              <Row className="g-0">
                <Col
                  xs={40}
                  className="d-flex align-items-center justify-content-center"
                >
                  <span
                    className="text-white fw-bold master-header-button-text pb-1"
                    style={{ lineHeight: "1" }}
                  >
                    Spara
                  </span>
                </Col>
              </Row>
            </Col>
          ) : (
            ""
          )}
          {currentPage === "Produktmixern" ||
          currentPage === "Fastakostnader" ||
          currentPage === "Åtgärder" ||
          currentPage === "Lonekalkyl" ? (
            <Col
              xs={1}
              className="offset-1 master-header-button p-1"
              style={{ padding: "0px" }}
              onClick={handleProfileSettings}
            >
              <Row className="g-0">
                <Col
                  xs={40}
                  className="d-flex align-items-center justify-content-center"
                >
                  <img
                    src={UserIcon}
                    alt="save to cloud icon"
                    className="img-fluid max-width:100% height:auto mx-auto d-block w-75 pt-1"
                  />
                </Col>
              </Row>
              <Row className="g-0">
                <Col
                  xs={40}
                  className="d-flex align-items-center justify-content-center"
                >
                  <span
                    className="text-white fw-bold master-header-button-text pb-1"
                    style={{ lineHeight: "1" }}
                  >
                    Konto
                  </span>
                </Col>
              </Row>
            </Col>
          ) : (
            ""
          )}
          {currentPage === "Produktmixern" ||
          currentPage === "Fastakostnader" ||
          currentPage === "Åtgärder" ||
          currentPage === "Lonekalkyl" ? (
            <Col
              xs={1}
              className="offset-1 master-header-button p-1"
              style={{ padding: "0px" }}
              onClick={handleLogout}
            >
              <Row className="g-0">
                <Col
                  xs={40}
                  className="d-flex align-items-center justify-content-center"
                >
                  <img
                    src={ExitIcon}
                    alt="exit icon"
                    className="img-fluid max-width:100% height:auto mx-auto d-block w-75 pt-1"
                  />
                </Col>
              </Row>
              <Row className="g-0">
                <Col
                  xs={40}
                  className="d-flex align-items-center justify-content-center"
                >
                  <span
                    className="text-white fw-bold master-header-button-text pb-1"
                    style={{ lineHeight: "1" }}
                  >
                    Avsluta
                  </span>
                </Col>
              </Row>
            </Col>
          ) : (
            ""
          )}
        </Row>
      </Col>
    </Row>
  );
};
export default Header;
